var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("AFFILIATED PHYSICIAN")]),_c('h4',[_vm._v("A duly licensed physician or specialist affiliated by HMI and named in the list of HMI’s affiliated physician with whom HMI has made arrangements to provide the required services under this Agreement.")])])
}]

export { render, staticRenderFns }